export const FREE_SHIP = 100;
export const FLAT_SHIP = 10;

export const TAGLINES = [
  "Good People. Sus Ideas.",
  "Certified Sus",
  "Not Your Average Crew",
  "Question the Usual",
  "Same Same? Suspect.",
  "For the Curious Kind",
  "Normal Is Overrated",
  "Normal Is Boring.",
];

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "bundles", label: "Bundles" },
  { id: "tees", label: "Tees" },
  { id: "hoodies", label: "Hoodies" },
  { id: "crewnecks", label: "Crewnecks" },
  { id: "caps", label: "Caps" },
  { id: "accessories", label: "Accessories" },
];

export const LOOKS = [
  { src: "/img/look_6.webp", alt: "Model in a black tee and cap sitting on a concrete ledge downtown Toronto", caption: "Queen St W" },
  { src: "/img/look_street_1.webp", alt: "Model in an olive hoodie and black cap walking beside a Toronto streetcar", caption: "Streetcar" },
  { src: "/img/look_7.webp", alt: "Model in a cream crewneck at a Toronto subway entrance", caption: "Queen Station" },
  { src: "/img/look_street_2.webp", alt: "Model in a black oversized tee and beanie leaning on a concrete wall", caption: "Concrete" },
  { src: "/img/look_8.webp", alt: "Hands holding a canvas tote and black cap against a concrete wall", caption: "Crew Tote" },
  { src: "/img/look_street_4.webp", alt: "Skater holding a board in a parking lot with the CN Tower behind", caption: "The 6ix" },
  { src: "/img/look_street_5.webp", alt: "Model in a black hoodie with hood up against a concrete wall", caption: "Certified sus" },
  { src: "/img/sus_vibes_wall.webp", alt: "Back view of a black hoodie facing a SUS VIBES ONLY graffiti wall", caption: "Sus vibes only" },
  { src: "/img/story_hoodie_back.webp", alt: "Back view of a cream hoodie against a pale concrete wall", caption: "Good people" },
];

export const ACCENTS = ["bg-lime", "bg-pink", "bg-sky"];
export const HLS = ["hl-lime", "hl-pink", "hl-sky"];
export const PROVINCES = [["AB", "Alberta"], ["BC", "British Columbia"], ["MB", "Manitoba"], ["NB", "New Brunswick"], ["NL", "Newfoundland and Labrador"], ["NS", "Nova Scotia"], ["NT", "Northwest Territories"], ["NU", "Nunavut"], ["ON", "Ontario"], ["PE", "Prince Edward Island"], ["QC", "Quebec"], ["SK", "Saskatchewan"], ["YT", "Yukon"]];
export const POSTAL_RE = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
export const nextDrop = (drops) => (drops || []).find((d) => d.status === "coming_soon") || (drops || []).filter((d) => new Date(d.release_date) > Date.now()).sort((a, b) => new Date(a.release_date) - new Date(b.release_date))[0];
export const imagesFor = (p, colorName) => {
  const c = p.colors.find((x) => x.name === colorName);
  return c?.images?.length ? [...c.images, ...p.images.filter((i) => !c.images.some((ci) => ci.src === i.src)).slice(1)] : p.images;
};

export const cad = (n) => `C$${Number(n).toFixed(2)}`;
export const cadShort = (n) => `C$${Number(n) % 1 ? Number(n).toFixed(2) : Number(n)} CAD`;
export const origin = () => window.location.origin;
export const abs = (p) => (p.startsWith("http") ? p : origin() + p);
export const totalStock = (p) => Object.values(p.sizes || {}).reduce((a, b) => a + b, 0);

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: abs(it.path) })),
});
